export default "__VITE_ASSET__8292257d__"